import React from "react";
import "./Clients.scss";

import migrartLogo from "../../assets/images/logos/migrart_logo.svg";
import dnsLogo from "../../assets/images/logos/dns.svg";
import slyzedLogo from "../../assets/images/logos/slyzed_logo.svg";
import nomaadLogo from "../../assets/images/logos/nomaad_logo.svg";

const clients = [
    { name: "Nomaad", logo: nomaadLogo },
    { name: "Migrart", logo: migrartLogo },
    { name: "Drop and Shop", logo: dnsLogo },
    { name: "Slyzed", logo: slyzedLogo },
];

const Clients = () => {
    return (
        <section
            className="clients"
            id="clients"
            aria-labelledby="clients-title"
        >
            <div className="clients__inner">
                <div className="clients__header">
                    <p className="clients__eyebrow">Our Clients</p>

                    <h2 id="clients-title">
                        Building Together with <span>Our Clients.</span>
                    </h2>
                </div>

                <ul className="clients__logos">
                    {clients.map((client) => (
                        <li className="clients__logo-card" key={client.name}>
                            <img
                                className="clients__logo"
                                src={client.logo}
                                alt={client.name}
                                loading="lazy"
                                decoding="async"
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default Clients;